/* =====================================================================
   COLDFRAME — 상품 상세 페이지 동작 (cf-product.js)
   카페24 _onedesign/js/detail.js + pages/js/product-detail*.js 이식 (jQuery 없음)
   - PC: 이미지 점 내비게이션 / 모바일: 이미지 슬라이드 + 썸네일
   - 아코디언, 옵션 선택 → 쇼피파이 상품 옵션(variant) 연결
   - 장바구니 담기(안내창) / 바로 구매 / 하단 고정 바 / 이미지 확대(선택)
   ===================================================================== */
(function () {
  'use strict';

  /* ---------------- PC 이미지 점 내비게이션 ---------------- */
  function initDotNav(root) {
    const nav = root.querySelector('#pcPrdNav');
    if (!nav) return;
    const dots = nav.querySelectorAll('a[data-id]');
    const header = document.getElementById('header');

    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        const target = root.querySelector('#' + dot.dataset.id);
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.pageYOffset;
        const headerHeight = header ? header.offsetHeight : 0;
        window.scrollTo({ top: top - headerHeight, behavior: 'smooth' });
      });
    });

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const activeId = entry.target.id;
          dots.forEach((dot) => dot.classList.toggle('on', dot.dataset.id === activeId));
        });
      },
      { root: null, rootMargin: '-35% 0px -35% 0px', threshold: 0.1 }
    );
    root.querySelectorAll('#keyImgThumbnail .p-detail-addimage-anchor').forEach((el) => observer.observe(el));
  }

  /* ---------------- 모바일 이미지 슬라이드 ---------------- */
  function initMobileSlider(root) {
    if (typeof window.Swiper !== 'function') return;
    const mainEl = root.querySelector('#mdSliderMain');
    const navEl = root.querySelector('#mdSliderThumbNav');
    if (!mainEl || mainEl.swiper) return;

    let thumbSwiper = null;
    if (navEl && navEl.querySelectorAll('.swiper-slide').length > 0) {
      thumbSwiper = new window.Swiper(navEl, {
        spaceBetween: 5,
        slidesPerView: 6.2,
        watchSlidesProgress: true,
        breakpoints: {
          600: { spaceBetween: 8.2 },
        },
      });
    }

    // eslint-disable-next-line no-new
    new window.Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: mainEl.querySelector('.swiper-custom-pagination'),
        clickable: true,
      },
      thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined,
    });
  }

  /* ---------------- 아코디언 (상세정보/사이즈/배송/교환·반품) ---------------- */
  function initAccordion(root) {
    root.querySelectorAll('.product-detail-accordion').forEach((container) => {
      const items = container.querySelectorAll('.accordion-item');
      items.forEach((item) => {
        const header = item.querySelector('.accordion-header');
        const content = item.querySelector('.accordion-content');
        if (!header || !content) return;

        const close = (it, ct) => {
          ct.style.maxHeight = ct.scrollHeight + 'px';
          void ct.offsetHeight; // reflow
          ct.style.maxHeight = '0px';
          it.classList.remove('active');
          const hd = it.querySelector('.accordion-header');
          if (hd) hd.setAttribute('aria-expanded', 'false');
          setTimeout(() => {
            if (!it.classList.contains('active')) ct.style.maxHeight = '';
          }, 400);
        };

        const toggle = () => {
          const isActive = item.classList.contains('active');
          items.forEach((other) => {
            if (other === item || !other.classList.contains('active')) return;
            const oc = other.querySelector('.accordion-content');
            if (oc) close(other, oc);
          });
          if (isActive) {
            close(item, content);
          } else {
            item.classList.add('active');
            header.setAttribute('aria-expanded', 'true');
            const target = content.scrollHeight;
            content.style.maxHeight = '0px';
            void content.offsetHeight; // reflow
            content.style.maxHeight = target + 'px';
          }
        };

        header.addEventListener('click', toggle);
        header.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  }

  /* ---------------- 옵션(variant) 선택 / 장바구니 ---------------- */
  function initProductForm(root) {
    const form = document.getElementById(root.dataset.formId);
    const dataEl = root.querySelector('[data-cf-product-json]');
    if (!form || !dataEl) return;

    let product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const idInput = form.querySelector('[data-cf-variant-id]');
    const selects = Array.from(root.querySelectorAll('select[data-cf-option]'));
    const priceEls = root.querySelectorAll('[data-cf-price], [data-cf-total-price]');
    const compareEl = root.querySelector('[data-cf-compare-price]');
    const addBtn = root.querySelector('[data-cf-add-to-cart]');
    const buyBtn = root.querySelector('[data-cf-buy-now]');
    const texts = {
      select: root.dataset.textSelect,
      add: root.dataset.textAdd,
      soldOut: root.dataset.textSoldOut,
      buy: root.dataset.textBuy,
    };

    const selectedValues = () => selects.map((s) => s.value);
    const allSelected = () => selects.every((s) => s.value !== '');

    const findVariant = () => {
      if (!product.hasOptions) return product.variants[0] || null;
      if (!allSelected()) return null;
      const values = selectedValues();
      return (
        product.variants.find((v) => v.options.every((opt, i) => selects[i] === undefined || opt === values[i])) || null
      );
    };

    const setButton = (btn, enabled, label) => {
      if (!btn) return;
      btn.disabled = !enabled;
      const span = btn.querySelector('span');
      if (span && label) span.textContent = label;
    };

    const update = (fromUser) => {
      const variant = findVariant();
      if (variant) {
        if (idInput) idInput.value = variant.id;
        // 가격 문구는 쇼피파이 money 형식(HTML 포함 가능) 그대로 사용
        priceEls.forEach((el) => {
          el.innerHTML = variant.price;
        });
        if (compareEl) {
          if (variant.compare) {
            compareEl.innerHTML = variant.compare;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        setButton(addBtn, variant.available, variant.available ? texts.add : texts.soldOut);
        setButton(buyBtn, variant.available, variant.available ? texts.buy : texts.soldOut);
        if (fromUser && product.hasOptions && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
        root.dispatchEvent(new CustomEvent('cf:variant-change', { bubbles: true, detail: { variant } }));
      } else if (product.hasOptions) {
        // 옵션을 다 고르기 전: 담기 버튼은 누를 수 있고, 누르면 옵션 선택 안내
        const anyAvailable = product.variants.some((v) => v.available);
        setButton(addBtn, anyAvailable, anyAvailable ? texts.add : texts.soldOut);
        setButton(buyBtn, anyAvailable, anyAvailable ? texts.buy : texts.soldOut);
      }
    };

    selects.forEach((select) => select.addEventListener('change', () => update(true)));
    update(false);

    // 어떤 버튼으로 제출했는지 (event.submitter 미지원 브라우저 대비)
    let lastSubmitter = null;
    [addBtn, buyBtn].forEach((btn) => {
      if (btn) btn.addEventListener('click', () => { lastSubmitter = btn; });
    });

    form.addEventListener('submit', (e) => {
      const submitter = e.submitter || lastSubmitter;
      lastSubmitter = null;

      if (product.hasOptions && !allSelected()) {
        e.preventDefault();
        window.alert(texts.select);
        const firstEmpty = selects.find((s) => s.value === '');
        if (firstEmpty) firstEmpty.focus();
        return;
      }
      const variant = findVariant();
      if (!variant || !variant.available) {
        e.preventDefault();
        return;
      }

      // 바로 구매: 기본 제출 (장바구니에 담은 뒤 결제 화면으로 이동)
      if (submitter && submitter === buyBtn) return;

      // 장바구니 담기: 페이지 이동 없이 담고 안내창 표시 (카페24와 동일)
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (addBtn) addBtn.setAttribute('aria-busy', 'true');

      const body = new FormData(form);
      fetch(root.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body,
      })
        .then((res) => res.json().then((json) => ({ ok: res.ok, json })))
        .then(({ ok, json }) => {
          if (!ok) {
            window.alert(json.description || json.message || 'Error');
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          showBasketLayer(root);
        })
        .catch(() => {
          form.submit();
        })
        .finally(() => {
          if (addBtn) addBtn.removeAttribute('aria-busy');
        });
    });
  }

  /* 장바구니 담기 안내창 (카페24 product/add_basket.html) */
  function showBasketLayer(root) {
    const tpl = root.querySelector('template[data-cf-basket-layer]');
    if (!tpl) return;
    const old = root.querySelector('#confirmLayer');
    if (old) old.remove();
    const layer = tpl.content.firstElementChild.cloneNode(true);
    root.appendChild(layer);

    const close = () => {
      layer.remove();
      document.removeEventListener('keydown', onKey);
    };
    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    layer.querySelectorAll('[data-cf-layer-close]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        close();
      });
    });
    layer.addEventListener('click', (e) => {
      if (e.target === layer) close();
    });
    document.addEventListener('keydown', onKey);
    const focusEl = layer.querySelector('.ec-base-button a');
    if (focusEl) focusEl.focus({ preventScroll: true });
  }

  /* ---------------- 하단 고정 바 (카페24 product-detail-bottom-modal.js) ---------------- */
  function initBottomModal(root) {
    const sticky = root.querySelector('.sticky-wrap');
    const modal = root.querySelector('#bottomModal');
    if (!sticky || !modal) return;
    const parent = sticky.parentElement;

    const remember = (el) => (el ? { el, parent: el.parentElement, next: el.nextElementSibling } : null);
    const items = [
      remember(root.querySelector('#totalProducts')),
      remember(root.querySelector('#cfGiftBox')),
      remember(root.querySelector('table.product-detail-option')),
      remember(root.querySelector('#actionCart')),
    ].filter(Boolean);

    let shown = false;
    const onScroll = () => {
      const bottom = parent.getBoundingClientRect().bottom;
      if (bottom <= 0 && !shown) {
        items.forEach((item) => modal.appendChild(item.el));
        modal.classList.add('has-content');
        document.body.classList.add('pb-modal-shown');
        shown = true;
      } else if (bottom > 0 && shown) {
        items.forEach((item) => {
          if (item.next && item.next.parentElement === item.parent) item.parent.insertBefore(item.el, item.next);
          else item.parent.appendChild(item.el);
        });
        modal.classList.remove('has-content');
        document.body.classList.remove('pb-modal-shown');
        shown = false;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    // 푸터가 보이면 하단 바를 내림 (카페24 footer-reached)
    if ('IntersectionObserver' in window) {
      const footer =
        document.querySelector('.shopify-section-group-footer-group .social-media') ||
        document.querySelector('.shopify-section-group-footer-group');
      if (footer) {
        const ob = new IntersectionObserver(([entry]) => {
          document.body.classList.toggle('footer-reached', entry.isIntersecting);
        });
        ob.observe(footer);
      }
    }
  }

  /* ---------------- 이미지 확대 (선택) ---------------- */
  function initZoom(root) {
    const buttons = root.querySelectorAll('[data-cf-zoom]');
    const dataEl = root.querySelector('[data-cf-product-json]');
    if (!buttons.length || !dataEl) return;
    let images = [];
    try {
      images = (JSON.parse(dataEl.textContent).zoom || []).map((i) => ({ src: i.src, width: i.width, height: i.height, alt: '' }));
    } catch (e) {
      return;
    }
    if (!images.length) return;
    const arrow =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7 2.49951L17 11.9995L7 21.4995" stroke="currentColor" stroke-width="1.5"></path></svg>';
    const closeSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m6 6 6 6m0 0-6 6m6-6 6-6m-6 6 6 6" stroke-width="1.5" stroke="currentColor"></path></svg>';

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        import('photoswipe')
          .then((mod) => {
            const PhotoSwipe = mod.default;
            const pswp = new PhotoSwipe({
              dataSource: images,
              index: 0,
              bgOpacity: 1,
              mainClass: 'cf-pswp',
              arrowPrevSVG: arrow,
              arrowNextSVG: arrow,
              closeSVG: closeSvg,
            });
            pswp.init();
          })
          .catch(() => {});
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cf-product]').forEach((root) => {
      if (root.dataset.cfInit === '1') return;
      root.dataset.cfInit = '1';
      initDotNav(root);
      initMobileSlider(root);
      initAccordion(root);
      initProductForm(root);
      initBottomModal(root);
      initZoom(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
